/**
 * @file コンポーネント：フル動画ページタイムライントピックコメント ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TimelineTopicComment = (props) => {
    return <Presenter {...props} />;
};
